import { get, post } from "@/utils/api";

export const ReportAPI = {
    getSalesItems: async (page) => {
        return await get("/report/sales-items", { page: page });
    },
    updateItemForecast: async (itemId, params) => {
        params = { ...params, id: itemId };
        return await post("/report/item-forecast", params);
    },
    getIncomeStatement: async (start, end) => {
        return await get("/report/income-statement", { startDate: start, endDate: end });
    },
    getBalanceSheet: async (date) => {
        return await get("/report/balance-sheet", { date: date });
    },
    getSaleHistory: async (params) => {
        return await get("/report/sale-history", params);
    }
}
